module.exports = __webpack_public_path__ + "static/feature-95f9055a8bbebb318fbded45082365d7.jpg";